module.exports = __webpack_public_path__ + "static/img/28.0d569da1.png";